import React from "react";

const AddDevice = () => {
  return (
    <div>
      <div>Add Device</div>
    </div>
  );
};

export default AddDevice;
